var path = '/app/pages/settings/settings.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/settings/settings.html
// module id = 981
// module chunks = 0